import { render, staticRenderFns } from "./defaultSwagbagFileForm.vue?vue&type=template&id=2f673073&"
import script from "./defaultSwagbagFileForm.vue?vue&type=script&lang=js&"
export * from "./defaultSwagbagFileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports